// extracted by mini-css-extract-plugin
export var active = "_sn-1";
export var circle = "_sn-0";
export var completed = "_sn-2";
export var connector = "_sn-4";
export var connectorCompleted = "_sn-7";
export var connectorSpacer = "_sn-5";
export var iconStrokeOverride = "_sn-8";
export var labelContainer = "_sn-6";
export var pending = "_sn-3";